export default __webpack_public_path__ + "static/header-b643deaffaf9494eebd3fa2b5c3b70e7.png";